import { atom } from 'jotai';

import { dateToEpochString } from '@flipster/utils/datetime';
import type { Position } from '@flipster/utils/types/position';

import { refPositionTimes } from '../../server-time';
import { updateV2SocketData } from '../v2-helper';
import { createTableAccumulatorBunja } from './table-accumulator';

export type Positions = Record<string, Position> | null;

export type { Position };

export const positionsAtom = atom<Positions>(null);

export const subscribePositionsBunja = createTableAccumulatorBunja('private/positions', (store) => (wsData) => {
  store.set(positionsAtom, (prev) => {
    const positions = updateV2SocketData(prev || {}, wsData);
    Object.entries(wsData).forEach(([action, values]) => {
      if (action === 's' || action === 'i' || action === 'u') {
        Object.entries(values as Record<string, Partial<Position>>).forEach(([positionKey, value]) => {
          const p = positions?.[positionKey];
          if (p && value.bboPriceTimestamp) {
            refPositionTimes[p.symbol] = {
              refServerTimestamp: value.bboPriceTimestamp,
              refClientTimestamp: dateToEpochString(new Date()),
            };
          }
        });
      }
    });
    return positions;
  });
});
